var menuState = false;
var dropState = false;

$(document).ready(function() {
  // 初期化
  sNavOut('.header__nav');

  // スライダー（slick）
  if($('.mainSlider').length){
    $('.mainSlider').slick({
      dots: true,
      arrow: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
    });
  }
  if($('.contentsSlider').length){
    $('.contentsSlider').each(function() {

      var pcshow = $(this).data('pcshow') ? $(this).data('pcshow') : 4;
      var pcscroll = $(this).data('pcscroll') ? $(this).data('pcscroll') : 4;
      var spshow = $(this).data('spshow') ? $(this).data('spshow') : 2;
      var spscroll = $(this).data('spscroll') ? $(this).data('spscroll') : 2;
      $(this).slick({
        dots: true,
        arrow: true,
        infinite: true,
        slidesToShow: pcshow,
        slidesToScroll: pcscroll,
        autoplay: true,
        autoplaySpeed: 5000,
        swipeToSlide:true,
        responsive: [{
          breakpoint: 991,  //ブレイクポイントを指定
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
          breakpoint: 768,
          settings: {
            slidesToShow: spshow,
            slidesToScroll: spscroll,
          }
        }]
      });
    });
  }

  if($('.mainVisual--integrate').length && $('.hdr--integrate').length){
    $('.hdr--integrate').addClass('active');
    $(window).on('scroll', function(event) {
      var scroll = $(window).scrollTop();
      if (scroll > 300 ){
        $('.hdr--integrate').addClass('integrate--fixed');
      }else{
        $('.hdr--integrate').removeClass('integrate--fixed');
      }
    });

  }

});

// ハンバーガーメニュー展開
$(document).on('click', '.menuToggle', function() {
  $('#drawer').toggleClass('open');
  $('#overlay').toggleClass('open');
  $('body').toggleClass('open');
  return false;
});

$(document).on('click', '.menuClose', function() {
  $('#drawer').removeClass('open');
  $('#overlay').removeClass('open');
  $('body').removeClass('open');
  return false;
});

// SPのみアコーディオン
$(document).on('click', '.sp-toggle', function() {
  var windowWidth = $(window).width();
  if (windowWidth < 768) {
    $(this).next('ul').slideToggle();
    $(this).toggleClass('open');
  }
});

$(document).on('click', '.hdrSearch--toggle > span,.hdrSearch--toggle > a', function() {
  $(this).next().slideToggle();
  return false;
});


// ナビゲーション　子要素展開
$(function() {
  var ua = navigator.userAgent;
  // タブレット・スマートフォン時
  if ((ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) && ua.indexOf('Mobile') > 0||ua.indexOf('iPad') > 0) {
    $('.hasChildren > a').on('mouseenter touchstart', function(){
      $(this).toggleClass('open');
      $(this).next('ul,.megaMenu').toggleClass('open');
      return false;
    }).on('mouseleave touchend', function(){
          return false;
    });
    $('.hasChildren .hasChildren--close > a').on('mouseenter touchstart', function(){
      $(this).parents('ul').removeClass('open').prev('a').removeClass('open');
      return false;
    });

  }else{
  // PC時
    $('.hasChildren').hover(function() {
      $(this).children('a').addClass('open');
      $(this).children('ul,.megaMenu').addClass('open');
    }, function() {
      $(this).children('a').removeClass('open');
      $(this).children('ul,.megaMenu').removeClass('open');
    });
  }
});

$(document).on('click', '.hasChildren--click > a,.hasChildren--click > span', function() {
  if (dropState == false) {
    $(this).addClass('open');
    $(this).next('ul').addClass('open');
    $(this).next('ul').slideDown();
    dropState = true;
  } else {
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
      $(this).next('ul').removeClass('open');
      $(this).next('ul').slideUp();
    } else {
      $(this).parents('li').parents('ul').parents('.gNav').find('.hasChilds > span').removeClass('open');
      $(this).parents('li').parents('ul').parents('.gNav').find('.hasChilds > span').next('ul').removeClass('open');
      $(this).parents('li').parents('ul').parents('.gNav').find('.hasChilds > span').next('ul').slideUp(0);
      $(this).addClass('open');
      $(this).next('ul').addClass('open');
      $(this).next('ul').slideDown();
    }
  }
  return false;
});

// SPヘッダーD　カテゴリーナビ
$(document).on('click', '.hdrCatMenu--toggle', function() {
  if($(this).hasClass('open')){
    $(this).removeClass('open');
    $(this).next('ul').removeClass('open');
    $(this).next('ul').slideUp();
  }else{
    $('.hdrCatMenu--toggle.open').next('ul').hide();
    $('.hdrCatMenu--toggle.open').next('ul').removeClass('open');
    $('.hdrCatMenu--toggle.open').removeClass('open');
    $(this).addClass('open');
    $(this).next('ul').addClass('open');
    $(this).next('ul').slideDown();
  }
  return false;
});


// ナビ固定
$(function() {
  var target = $(".hdrFixed");
  if($(".hdrFixed").length){
    var h = target.height();
    var h_top = target.offset().top;
    target.after('<div class="h_box"></div>');
    $(".h_box").height("0");
    $(window).on('load scroll', function(event) {
      var scroll = $(window).scrollTop();
      if (scroll >= h_top) {
        target.css({
          position: 'fixed',
          top: '0px',
          width: '100%',
          'z-index': '998'
        });
        $(".h_box").height(h);
      } else {
        target.css({
          position: ''
        });
        $(".h_box").height("0");
      }
    });
  }
});


function sNavIn(_this) {
  var windowWidthMinus = document.documentElement.clientWidth * -1;
  $(_this).addClass('open');
  $('.menuBg--close').addClass('open');
  $(_this).css({
    'left': 0
  });
}

function sNavOut(_this) {
  var windowWidthMinus = document.documentElement.clientWidth * -1;
  $(_this).removeClass('open');
  $('.menuBg--close').removeClass('open');
  $(_this).css({
    'left': windowWidthMinus
  });
}

// タブ切り替え
$(function() {
  $(".tabSwitch > li ").click(function() {
    if (!$(this).hasClass('active')) {
      $(this).parents('.tabSwitch').find('li').removeClass('active');
      $(this).addClass('active');

      var tabNum = $(this).index();
      $(this).parents(".tab").find(".tabContents").find(".tabContent").hide();
      $(this).parents(".tab").find(".tabContents").find(".tabContent").eq(tabNum).fadeIn("500");
    }
  });
});

// スクロールボタン
$(function() {
  if ($('.mainSliderSec').length || $('.mainVisual').length) {
    if($('.mainVisual--hero').length){
      var position = $(window).height();
    }else if ($('.mainSliderSec').length) {
      var position = $(".mainSliderSec + * ").offset().top;
    }else{
      var position = $(".mainVisual + * ").offset().top;
    }
    $("#scrollBtn").click(function() {
      $("html,body").animate({
        scrollTop: position // さっき変数に入れた位置まで
      }, {
        queue: false // どれくらい経過してから、アニメーションを始めるか。キュー[待ち行列]。falseを指定すると、キューに追加されずに即座にアニメーションを実行。
      });
      return false;
    });
  }
});

// テキスト横スクロール
var spSwiperDone = false;
$(window).on('load resize', function(event) {
  if (window.innerWidth < 992 && spSwiperDone == false) {
    $('.spSwiper').slick({
      autoplay: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      variableWidth: true,
      touchMove: true,
      swipeToSlide: true,
      infinite: false
    });

    spSwiperDone= true;
  }
});



// クリモカレンダー
$(function(){
    $('.dayList').each(function(){
        var month = $(this).attr('data-month');
        var day = $(this).attr('data-day');
        var color = $(this).attr('data-color');
        $('.makeshop-calendar' + month +' .day' + day).css({
            'background-color': color,
            'color': '#fff',
            'font-weight': 'bold'
        });
    });
});

if($(".wow").length){
  $(window).on('scroll',function(){
    console.log('');
    $(".wow").each(function(){
      var position = $(this).offset().top;
      var height = $(this).height();
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > position - windowHeight + windowHeight / 4 ){
        $(this).addClass('animated');
      }
    });
  });
}
